import * as React from 'react';
import axios from 'axios';
import Menu from '@mui/material/Menu';
import { Form, FormikProvider, useFormik } from 'formik';
import { TextField, Button, Stack, MenuItem, Grid, Card, Collapse, IconButton, Typography, Box } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import Iconify from '../Iconify';

const Filter = ({ filterValues, applyFilters }) => {
  const [open, setOpen] = React.useState(false);
  const [memberRoles, setMemberRoles] = React.useState([]);

  const formik = useFormik({
    initialValues: {
      id: filterValues.id,
      fullname: filterValues.fullname,
      isBlocked: filterValues.isBlocked,
      role: filterValues.role,
      email: filterValues.email,
    },
    onSubmit: async () => {
      applyFilters(values);
    },
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, resetForm } = formik;
  const getMemberRoles = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/memberRole/list`);
      if (!response.data.isError) {
        console.log(response.data.data);
        setMemberRoles(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    getMemberRoles();
  }, []);

  return (
    <Box mb={2}>
      <Stack direction="row" spacing={2} justifyContent="end" alignItems="center" width="100%">
        <IconButton onClick={() => setOpen(!open)}>
          <Iconify icon="ic:round-filter-list" />
          <Typography variant="h6"> Filter</Typography>
        </IconButton>
      </Stack>
      <Collapse in={open}>
        <Box sx={{ marginBottom: '10px' }}>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Grid container spacing={1} padding={1}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField fullWidth id="id" name="id" label="Employee ID" {...getFieldProps('id')} />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField fullWidth id="fullname" name="fullname" label="Fullname" {...getFieldProps('fullname')} />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField fullWidth id="email" name="email" label="Email" {...getFieldProps('email')} />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField select fullWidth id="role" name="role" label="Role" {...getFieldProps('role')}>
                    {memberRoles.map((role) => (
                      <MenuItem key={role.id} value={role.name}>
                        {role?.name?.replaceAll('_', ' ')}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                  <TextField
                    select
                    fullWidth
                    id="isBlocked"
                    name="isBlocked"
                    label="Status"
                    {...getFieldProps('isBlocked')}
                  >
                    <MenuItem value="true">Blocked</MenuItem>
                    <MenuItem value="false">Active</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} justifyContent="center" display="flex">
                  <Stack direction="row" spacing={5}>
                    <Button
                      variant="contained"
                      style={{ marginTop: '10px' }}
                      onClick={() => {
                        resetForm();
                        applyFilters({
                          id: '',
                          fullname: '',
                          isBlocked: '',
                          role: '',
                          email: '',
                        });
                      }}
                    >
                      Reset
                    </Button>
                    <Button variant="contained" type="submit" style={{ marginTop: '10px' }}>
                      Filter
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </Box>
      </Collapse>
    </Box>
  );
};

export default Filter;
